import { render } from "./LockScreen.vue?vue&type=template&id=6a8704d3&scoped=true"
import script from "./LockScreen.vue?vue&type=script&lang=js"
export * from "./LockScreen.vue?vue&type=script&lang=js"

import "./LockScreen.vue?vue&type=style&index=0&id=6a8704d3&lang=scss&scoped=true"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8704d3"]])

export default __exports__